import React from 'react'
import '../../images/banner.jpg'

const Header = () => {

  return (
    <>
{/*     
     <section class="home" id="home">
        <div class="max-width">
            <div class="home-content">
                <div class="text-1">Hello, my name is</div>
                <div class="text-2">Abdulrahman Adekeye</div>
                <div class="text-3">And I'm a <span class="typing">Web Developer</span></div>
                <a
                    href="assets/ABDULRESUME.pdf" 
                    className="btn btn-info py-1 text-light"
                    download={'ABDULRESUME.pdf'}
                 > 
                       download resume 
                </a>
         </div>
         <div className='d-flex child-2' style={{ marginLeft : -20 }}>
         
         </div>
         </div>
            
        
    </section> */}
         <section class="home" id="home">
         <div class="max-width">
            <div class="home-content">
     <header className='d-flex page-header justify-content-center align-items-center'>         
         <div className=' header-text'>
               <h2 className='text-center text-5xl'>  <big className='text-info mb-0 p-0'> Hi </big> i'm Abdulrahman</h2>
               <h6 className='mt-0 p-0 text-center  '>   Web Developer | Physicists </h6>
                <p className='m-0 p-0 text-center mx-auto'>
                    A highly skilled and motivated web developer who deliver best quality and 
                    scalable software for your business . 
                </p>
                 <div className='d-flex justify-content-center w-100'>
                 <a
                    href="assets/ABDULRESUME.pdf" 
                    className="btn btn-info py-1 text-light"
                    download={'ABDULRESUME.pdf'}
                 > 
                       download resume 
                </a>
                 </div>
         </div>                 
     </header>
          </div> 
          </div>    
     </section>
    </>
  )
}

export default Header